import endpoints from './endpoints';

const constants = {
  endpoints,
};

export default constants;
